import fetchClient from '../config/client';
import axios from 'axios';

const getPresignedUrl = async (data) => {
  let response = await fetchClient
    .put(`/coordinator/document_attachments/presign_upload`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(function (res) {
      return res;
    });
  return response;
};

const uploadToS3 = async (presigned_url, file) => {
  let file_type = file.type;

  await axios
    .put(presigned_url, file, {
      headers: {
        'Content-Type': file_type,
      },
    })
    .then((result) => {})
    .catch((err) => {
      console.log(err);
    });
};

const presignDelete = async (id) => {
	let response = await fetchClient
	.get(`/coordinator/document_attachments/${id}/presign_delete`, { headers: { 'Content-Type': 'application/json' } })
	.then(function (res) {
		if (res.status == 200){
			return res
		}else{
			return res
		}
	}).catch((err) => {
		console.log(err);
	});
};

export const AwsActions = {
  getPresignedUrl,
  uploadToS3,
	presignDelete
};

export default AwsActions;
